import React from 'react';
import Button from './Button';
import * as Icons from '../../assets/svg/icons';

const Controls = ({
  isMicOn,
  isVideoOn,
  onToggleMic,
  onToggleVideo,
  onSwitchCamera,
  onScreenshot,
  onOpenSettings,
  onEndCall,
  onFullscreen,
  minimalControls = false // when true (pharmacist side): only screenshot + end call
}) => {
  return (
    <div 
      className={`video-call-controls-bar flex items-center py-2 px-4 border max-w-[calc(100vw-2rem)] ${
        minimalControls ? 'justify-between min-w-[150px]' : 'justify-center gap-0.5'
      }`}
      style={{ 
        backgroundColor: 'rgba(39, 39, 42, 0.95)',
        borderColor: 'rgba(255, 255, 255, 0.08)',
        borderRadius: '9999px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.4)'
      }}
    >
      {!minimalControls && (
        <>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onToggleMic}
        className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
        style={!isMicOn ? { backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#ef4444' } : { color: '#e4e4e7' }}
        aria-label="Toggle Mic"
      >
        {isMicOn ? <Icons.MicIcon className="w-5 h-5" color="currentColor" /> : <Icons.MicOffIcon className="w-5 h-5" color="currentColor" />}
      </Button>

      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onToggleVideo}
        className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
        style={!isVideoOn ? { backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#ef4444' } : { color: '#e4e4e7' }}
        aria-label="Toggle Video"
      >
        {isVideoOn ? <Icons.VideoIcon className="w-5 h-5" color="currentColor" /> : <Icons.VideoOffIcon className="w-5 h-5" color="currentColor" />}
      </Button>

      {onFullscreen && (
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onFullscreen}
          className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
          style={{ color: '#e4e4e7' }}
          aria-label="Fullscreen"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
          </svg>
        </Button>
      )}

      {onSwitchCamera && (
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onSwitchCamera}
          className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
          style={{ color: '#e4e4e7' }}
          aria-label="Switch Camera"
        >
          <Icons.CameraFlipIcon className="w-5 h-5" color="currentColor" />
        </Button>
      )}
        </>
      )}

      {/* Pharmacist side: mute (mic toggle) */}
      {minimalControls && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleMic}
          className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
          style={!isMicOn ? { backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#ef4444' } : { color: '#e4e4e7' }}
          aria-label="Toggle Mic"
        >
          {isMicOn ? <Icons.MicIcon className="w-5 h-5" color="currentColor" /> : <Icons.MicOffIcon className="w-5 h-5" color="currentColor" />}
        </Button>
      )}

      {onScreenshot && (
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onScreenshot}
          className="rounded-full w-10 h-10 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
          style={{ color: '#e4e4e7' }}
          aria-label="Take screenshot"
        >
          <Icons.ScreenshotIcon className="w-5 h-5" color="currentColor" />
        </Button>
      )}

      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onEndCall}
        className="rounded-full w-10 h-10 flex-shrink-0 transition-all duration-200 focus:outline-none focus:ring-0 focus:ring-offset-0"
        style={{ color: '#e4e4e7' }}
        aria-label="End Call"
      >
        <Icons.CallEndedIcon className="w-5 h-5" color="currentColor" />
      </Button>
    </div>
  );
};

export default Controls;